import { render, staticRenderFns } from "./TotalComponent.vue?vue&type=template&id=386e68a8&"
import script from "./TotalComponent.vue?vue&type=script&lang=js&"
export * from "./TotalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports